<script setup lang="ts">
import ViewLayout from '@/views/layouts/ViewLayout.vue'
import HistoricalRTLMPChart from '@/components/eos/charts/HistoricalRTLMPChart.vue'
</script>

<template>
  <ViewLayout>
    <HistoricalRTLMPChart />
  </ViewLayout>
</template>
